/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowtitle2Inputs */

const en_aiflowtitle2 = /** @type {(inputs: Aiflowtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New event`)
};

const de_aiflowtitle2 = /** @type {(inputs: Aiflowtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neues Event`)
};

/**
* | output |
* | --- |
* | "New event" |
*
* @param {Aiflowtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowtitle2 = /** @type {((inputs?: Aiflowtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowtitle2(inputs)
	return de_aiflowtitle2(inputs)
});
export { aiflowtitle2 as "aiFlowTitle" }